<section class="cz-recommendations-component">
  <mat-accordion multi="true">
    <mat-expansion-panel *ngIf="recommendationsOpenForUser$ | async as recommendationsOpenForUser" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title class="truncate">
          <span [innerHTML]="'$nav_accordions_open_recommendations' | translate" class="truncate"></span> <span class="font-size-small badge">{{ recommendationsOpenForUser.length }}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <cz-recommendation-card *ngFor="let recommendation of recommendationsOpenForUser" [cultureCookie]="cultureCookie" [backupLanguageId]="backupLanguageId" [recommendation]="recommendation"></cz-recommendation-card>
    </mat-expansion-panel>
    <mat-expansion-panel *ngIf="recommendationsCompletedForUser$ | async as recommendationsCompletedForUser">
      <mat-expansion-panel-header>
        <mat-panel-title class="truncate">
          <span [innerHTML]="'$nav_accordions_completed_recommendations' | translate" class="truncate"></span> <span class="font-size-small badge">{{ recommendationsCompletedForUser.length }}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <cz-recommendation-card *ngFor="let recommendation of recommendationsCompletedForUser | arraySlice: closedRecommendationCount" [recommendation]="recommendation" [cultureCookie]="cultureCookie" [backupLanguageId]="backupLanguageId"></cz-recommendation-card>
      <div *ngIf="!allShownRecs" class="load-more-container">
        <button mat-button (click)="loadMoreClosedRecs()" color="accent" [innerHTML]="'$btn_load_more' | translate"></button>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</section>
